import { BookOpen, Headphones, Languages, Video, Film, Sparkles } from "lucide-react";

const data = [
  {
    id: 1,
    icon: BookOpen,
    title: "Read Stories",
    description: "Dive into immersive ebooks and tales crafted for every age group."
  },
  {
    id: 2,
    icon: Headphones,
    title: "Audio Kahaniyan",
    description: "Listen to engaging stories in Hindi, English, and Garhwali—anytime, anywhere."
  },
  {
    id: 3,
    icon: Languages,
    title: "Multilingual Fun",
    description: "Explore cultural richness through stories in multiple Indian languages."
  },
  {
    id: 4,
    icon: Sparkles,
    title: "Suno Shorts",
    description: "Quick, creative short videos packed with fun and imagination for all ages."
  },
  {
    id: 5,
    icon: Film,
    title: "Documentary & Kids",
    description: "Inspiring documentaries and fun-filled content curated specially for children."
  },
  {
    id: 6,
    icon: Video,
    title: "Watch & Enjoy",
    description: "Enjoy a growing collection of long-form storytelling videos and special features."
  }
];

export default data;
